import { ClaimDetails } from './claim-details.model';
import { UploadDocuments } from './upload-documents.model';

export class ClaimDetailsResponse {
  public claimDetails: ClaimDetails;
  public documents: UploadDocuments;
  public responses: { [index: string]: [string, string] };
}
